import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { IconMessageWrapper as CompiledIconMessageWrapper } from './iconMessageWrapper-compiled';
import { IconMessageWrapper as EmotionIconMessageWrapper } from './iconMessageWrapper-emotion';
export var IconMessageWrapper = function IconMessageWrapper(props) {
  return fg('platform_media_compiled') ? /*#__PURE__*/React.createElement(CompiledIconMessageWrapper, props) : /*#__PURE__*/React.createElement(EmotionIconMessageWrapper, props);
};